export default __webpack_public_path__ + "images/DefaultIcon_2ae1bb5.jpg";